// @ts-ignore
import Filter from "bad-words";

const filter = new Filter();

filter.removeWords("fart", "lesbian");

export default filter;
